if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.formWrapper = document.getElementById("product-form-wrapper");
        this.header = document.getElementById("Header");
        this.stickyAtc = this.firstElementChild;
        this.stickyAtc.id = "sticky-atc";
      }

      connectedCallback() {
        // when color is changed, old sticky should be removed from the header
        setTimeout(() => {
          this.clean();
        }, 1);

        // init observer
        this.observer = new IntersectionObserver(
          this.handleIntersect.bind(this)
        );
        this.observer.observe(this.formWrapper);
      }

      clean() {
        const oldSticky = this.header.querySelectorAll("#sticky-atc");
        if (oldSticky) {
          oldSticky.forEach((sticky) => {
            this.header.removeChild(sticky);
          });
        }
      }

      detach() {
        // https://youtu.be/_GdEsdEfZvc?t=131
        this.observer.unobserve(this.formWrapper);
      }

      handleIntersect(entries) {
        entries.forEach((entry) => {
          const formRect = this.formWrapper.getBoundingClientRect();
          const isFormAboveFold = formRect.bottom < 100;

          if (!entry.isIntersecting && isFormAboveFold) {
            if (window.innerWidth < 1024) {
              document.body.appendChild(this.stickyAtc);
            } else {
              this.header.appendChild(this.stickyAtc);
            }
            this.stickyAtc.classList.remove("hidden");
            document.body.classList.add("sticky-atc-is-active");
          } else {
            if (
              this.stickyAtc.parentElement === this.header ||
              this.stickyAtc.parentElement === document.body
            ) {
              this.hide();
            }
          }
        });
      }
      hide() {
        if (window.innerWidth < 1024) {
          document.body.removeChild(this.stickyAtc);
        } else {
          this.header.removeChild(this.stickyAtc);
        }
        document.body.classList.remove("sticky-atc-is-active");
      }
    }
  );
}
